import authorize from './authorize'
import getTokenAndUserInfo from './getTokenAndUserInfo'

const itsme = {
  authorize,
  getTokenAndUserInfo
}

export default itsme
